/* Product image */

$(document).on('click', '.product-gallery .image-wrapper', function () {
      var images = [],
      $imgs = $(this).closest('.product-gallery').find('.image-wrapper'),
      clickedHref = $(this).attr('href');
  
      if ($imgs.length) {        
        $imgs.each(function () {
          var $imgThumb = $(this).clone();
          $imgThumb.addClass('lazyload').parent().addClass('lazyload--placeholder');
          images.push({
            thumbTag: $imgThumb,
            zoomUrl: $(this).attr('href') });
        });
      } else {       
        var $img = $(this).clone();
        $img.addClass('lazyload').parent().addClass('lazyload--placeholder');
        images.push({
          thumbTag: $img,
          zoomUrl: $(this).attr('href') });

      }

      theme.buildGalleryViewer({
        images: images,
        currentImage: clickedHref,
        prev: theme.icons.chevronLeft,
        next: theme.icons.chevronRight,
        close: theme.icons.close });
  
      return false;
});

/* Wishlist */

const storage = localStorage.getItem("wishlist");
const wishlist = storage ? JSON.parse(storage) : [];

const wishlistButton = document.getElementById('wishlist-add');
if (wishlistButton && wishlist.some(product => product.id === wishlistButton.dataset.id )) {
	wishlistButton.classList.add("wishlisted");
}
wishlistButton?.addEventListener("click", () => addToWishlist(wishlistButton, '/pages/wishlist'));

const wishlistQuote = document.getElementById('wishlist-quote');
wishlistQuote?.addEventListener("click", () => addToWishlist(wishlistQuote, '/pages/contact'));

function addToWishlist(target, redirect) {
  const productData = {
		"id": target.dataset.id,
		"url": target.dataset.url,
		"title": target.dataset.title,
		"image": target.dataset.image,
		"price": target.dataset.price
	}
	
	target.classList.add("wishlisted");

	if ( !wishlist.find( (product) => product.id === target.dataset.id ) ) {
		localStorage.setItem('wishlist', JSON.stringify([...wishlist, productData]));
	}

    if (redirect) {
      window.location.href = redirect;
    }
}

renderWishlist(wishlist);
renderFormWishlist(wishlist);


function removeFromWishlist() {
  
  const removeButtons = document.querySelectorAll('.wishlist-remove');
  removeButtons.forEach((button) => {
  	button.addEventListener("click", function(){

        const storage = localStorage.getItem("wishlist");
        const wishlist = storage ? JSON.parse(storage) : [];
      
  		const newWishlist = [...wishlist].filter( (product) => {
  			return product.id !== button.dataset.id;
  		});
  		renderWishlist(newWishlist);
  		localStorage.setItem('wishlist', JSON.stringify(newWishlist));
        removeFromWishlist();
  	});
  });
}
removeFromWishlist();

function renderWishlist(wishlist) {
	const wishlistPage = document.getElementById('wishlist-page');
	const noProductTitle = 'Non hai ancora aggiunto alcun prodotto alla tua wishlist.';
    const noProductMessage = 'Puoi navigare nel nostro catalogo e aggiungere i prodotti che ti interessano con il pulsante a forma di cuore. Altrimenti, specifica nel messaggio i prodotti a cui sei interessato.';
	
	if (wishlistPage) { 

		wishlistPage.innerHTML = "";
		wishlist.forEach( (product) => {
			wishlistPage.innerHTML += "<div class='product-card'><div class='img-wrapper'><a href='" + product.url + "'><img src='" + product.image + "' alt='" + product.title + "'/></a></div><div class='description'><a href='" + product.url + "'>" + product.title + "</a><button class='wishlist-remove' data-id='" + product.id + "'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d='M135.2 17.69C140.6 6.848 151.7 0 163.8 0H284.2C296.3 0 307.4 6.848 312.8 17.69L320 32H416C433.7 32 448 46.33 448 64C448 81.67 433.7 96 416 96H32C14.33 96 0 81.67 0 64C0 46.33 14.33 32 32 32H128L135.2 17.69zM394.8 466.1C393.2 492.3 372.3 512 346.9 512H101.1C75.75 512 54.77 492.3 53.19 466.1L31.1 128H416L394.8 466.1z'/></svg></button></div></div>";
		});

		if (wishlist.length < 1) {
			wishlistPage.innerHTML = "<div class='message'><h2>" + noProductTitle + "</h2><p>" + noProductMessage + "</p></div>";
		}
	}
}

function renderFormWishlist(wishlist) {
  const wishlistDiv = document.getElementById('form-wishlist');
  const wishlistTitle = wishlistDiv?.dataset.title;
  const noProductMessage = wishlistDiv?.dataset.empty;

  if (wishlistDiv) {
    let html = '';
    let wishlistItems = '';

    html = "<label>" + wishlistTitle + "</label><div class='grid'>";

    wishlist.forEach((product) => {
      html += `
        <div class='product-card'>
          <div class='img-wrapper'>
            <img src='${product.image}' alt='${product.title}'/>
          </div>
          <div class='description'>${product.title}</div>
          <button class='wishlist-remove' data-id='${product.id}'>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
              <!-- Font Awesome icon for remove -->
              <path d='M135.2 17.69C140.6 6.848 151.7 0 163.8 0H284.2C296.3 0 307.4 6.848 312.8 17.69L320 32H416C433.7 32 448 46.33 448 64C448 81.67 433.7 96 416 96H32C14.33 96 0 81.67 0 64C0 46.33 14.33 32 32 32H128L135.2 17.69zM394.8 466.1C393.2 492.3 372.3 512 346.9 512H101.1C75.75 512 54.77 492.3 53.19 466.1L31.1 128H416L394.8 466.1z'/>
            </svg>
          </button>
        </div>
      `;
      wishlistItems += product.title + ", ";
    });

    html += "<input type='hidden' name='contact[Wishlist]' value='" + wishlistItems.slice(0, -2) + "' /></div>";

    if (wishlist.length < 1) {
      wishlistDiv.innerHTML = "<label>" + wishlistTitle + "</label><div class='message'>" + noProductMessage + "</div>";
    } else {
      wishlistDiv.innerHTML = html;
    }
  }

  // Aggiungi evento click per ogni pulsante di rimozione
  const removeButtons = document.querySelectorAll('.wishlist-remove');
  removeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const productId = button.dataset.id;

      // Rimuovi l'elemento dalla wishlist
      const updatedWishlist = wishlist.filter((product) => product.id !== productId);
      localStorage.setItem('wishlist', JSON.stringify(updatedWishlist));

      // Rendi nuovamente la wishlist aggiornata
      renderFormWishlist(updatedWishlist);
    });
  });
}



/* Downloads */

const downloadFilter = document.getElementById('filter-downloads');
const filterableDownload = document.querySelectorAll('.filterable-download');

downloadFilter?.addEventListener("input", function(event) {
  filterableDownload.forEach((product) => {
    if (event.target.value.length > 2 && !product.dataset.product.toLowerCase().includes(event.target.value.toLowerCase())) {
      product.style.display = "none";
    } else {
      product.style.display = "block";
    }
  });
});

